import { createAction } from '@ngrx/store';

export enum LandingPageActions {
  SubmitDefaults = '[Landing Page] Submit default values',
  ClearInputData = '[Landing Page] clear all input values',
  ResetCostTables = '[Landing Page] Reset both cost tables',
}

export const submitDefaults = createAction(
  '[Landing Page] Submit default values'
);

export const clearInputData = createAction(
  '[Landing Page] clear all input values'
);

export const resetCostTables = createAction(
  '[Landing Page] Reset both cost tables'
);
